import { useEffect, useState } from "react";
import { api, trackVisit } from "../lib/api";
import PageHero from "../components/site/PageHero";
import { ShieldCheck, Sparkles, Coins, Gem } from "lucide-react";

const iconMap = { Coins, Gem, Sparkles, ShieldCheck };
const SERVICE_IMG = "https://static.prod-images.emergentagent.com/jobs/41158db5-39b3-4ac2-97f0-f1c825b2e80a/images/2e54f4e5b5a343640fa8c65050d74634631a9ba2872663fc999b41b27452c184.png";

export default function Servizi() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    trackVisit("servizi");
    api.get("/content").then((r) => setServices(r.data?.services || []));
  }, []);

  return (
    <div data-testid="servizi-page">
      <PageHero
        eyebrow="I Nostri Servizi"
        title="Solo oro,"
        titleAccent="solo argento."
        subtitle="Specializzati esclusivamente nell'acquisto di oro e argento. Nessuna distrazione, solo competenza pura sui metalli preziosi."
      />

      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Sparkles;
            return (
              <div key={i} data-testid={`servizio-${i}`} className="luxe-card p-9 group">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 border border-[var(--gold)]/40 flex items-center justify-center group-hover:border-[var(--gold)] transition-colors">
                    <Icon size={22} className="text-[var(--gold)]" strokeWidth={1.3} />
                  </div>
                  <span className="font-mono text-xs text-white/30">0{i + 1}</span>
                </div>
                <h3 className="font-serif text-2xl text-white mb-3">{s.title}</h3>
                <p className="text-sm text-[var(--text-secondary)] leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-28 bg-[#060f1f]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
          <img src={SERVICE_IMG} alt="" className="w-full h-[460px] object-cover rounded-sm" />
          <div>
            <span className="text-[0.7rem] uppercase tracking-[0.4em] text-[var(--gold)]">— Carature trattate</span>
            <h2 className="font-serif text-5xl text-white mt-4 mb-6">Oro 24·22·21·18·14·9kt<br/>+ Argento 925</h2>
            <p className="text-[var(--text-secondary)] mb-8 leading-relaxed">
              Acquistiamo oro in tutte le carature, dal 24 carati puro al 9 carati. Per l'argento valutiamo principalmente il titolo 925. La valutazione è sempre gratuita e senza impegno.
            </p>
            <ul className="space-y-3 text-sm">
              {[
                "Pesatura con bilance certificate",
                "Verifica caratura con saggi non distruttivi",
                "Quotazione trasparente in €/grammo",
                "Pagamento immediato in negozio",
              ].map((p, i) => (
                <li key={i} className="flex items-center gap-3 text-white/80">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--gold)]" /> {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
